<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Autre(s) autorisation(s) de pratique</legend>
        <section class="body-2">
          <p class="mentionLegal">
            Veuillez remplir cette page si vous êtes membre d'un ou plusieurs autres ordres du Québec ou d'un autre
            ordre/instance réglementaire en travail social au Canada. Sinon, cliquez suivant.
          </p>
        </section>
        <v-autocomplete v-model="getAutresAutorisationsDePratique.membreDUnAutreOrdre"
                        :item-text="itemText"
                        :item-value="itemValue"
                        :items="listesAutresOrdres"
                        clearable
                        label="Membre d'un ou plusieurs ordres du Québec"
                        multiple
                        return-object></v-autocomplete>

        <!-- NumeroDePermisDePsychotherapeuteSiApplicable -->
        <v-text-field v-model="getAutresAutorisationsDePratique.numeroDePermisDePsychotherapeuteSiApplicable"
                      label="Numéro de permis de psychothérapeute, si applicable"></v-text-field>

        <!-- Citoyennete -->
        <v-autocomplete v-model="getAutresAutorisationsDePratique.instancesReglementairesEnTravailSocialHorsQuebec"
                        :item-text="itemText"
                        :item-value="itemValue"
                        :items="listesInstancesReglementaires"
                        clearable
                        label="Instances règlementaires en Travail social hors Québec"
                        multiple
                        return-object></v-autocomplete>

        <v-col class="legalSection">
          <Attachment ref="instanceAttachment"
                      file-prefix="instance_justificatif"
                      :min-required="0"
                      @completeEvent="saveNextAttachment"
                      @refreshEvent="validateForm(true)"></Attachment>
        </v-col>
      </fieldset>
    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid" color="secondary" @click="saveAndContinueLater()">Enregistrer et terminer plus
        tard
      </v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Attachment from "../attachments/Attachment"
import Loader from "../Loader"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"
import AttachementFormulaireMixin from "@/mixins/attachementFormulaireMixin"

export default {
  mixins: [
    NavigationPageFormulaireMixin,
    PageReadonlyFormulaireAdmissionMixin,
    AttachementFormulaireMixin,
  ],
  props: {
    routeName: {
      type: String,
      default: ''
    },
  },
  components: {
    Attachment: Attachment,
    Loader: Loader
  },
  data () {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      contactId: "DemandeAdmission/GET_CONTACTID",
      getAutresAutorisationsDePratique: "AutresAutorisationsDePratique/GET_AUTRESAUTORISATIONDEPRATIQUES",
      listesAutresOrdres: "Catalogue/GET_AUTRESORDRE",
      listesInstancesReglementaires: "Catalogue/GET_INSTANCESREGLEMENTAIRES",
      getAutorisation: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      getFormations: "FormationInitiale/GET_FORMATIONS",
    }),
    hasAutorisationSpecial: function () {
      return this.getAutorisation.find(a => a.categorieAutorisation.id == this.$catalogues.categorieAutorisation.autorisationSpeciale) ||
          this.getFormations.find(f => f.formationUniversitaireEnTravailSocial.id == process.env.VUE_APP_FORMATION_DIPLOME_AUTREAUTORISATIONSPECIALE)
    },
  },
  created () {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      updateAutresAutorisationsDePratique: "AutresAutorisationsDePratique/updateAutresAutorisationsDePratique",
      createAutresAutorisationsDePratique: "AutresAutorisationsDePratique/createAutresAutorisationsDePratique",
      getAutresAutorisationsDePratiqueByDemandeAdmissionId: "AutresAutorisationsDePratique/getAutresAutorisationsDePratiqueByDemandeAdmissionId",
      getDocumentsByDemandeAdmissionId: "Documents/getDocumentsByDemandeAdmissionId",
    }),
    async fetchItems () {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        if (this.demandeAdmissionId) {
          await this.getAutresAutorisationsDePratiqueByDemandeAdmissionId(this.demandeAdmissionId)
          await this.getDocumentsByDemandeAdmissionId(this.demandeAdmissionId)
        }

        // Catalogue MembreAutresOrdres
        this.getCatalogue(2601)

        // Catalogue AInstances reglementaires
        this.getCatalogue(2603)

        // Liste les uploads de fichiers
        this.refsUpload = [
          () => this.$refs.instanceAttachment,
        ]

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    save () {
      this.$refs.form.validate()
      if (this.valid) {
        this.messageSelector = "Save"
        this.overlay = true

        if (this.demandeAdmissionId) {
          this.getAutresAutorisationsDePratique.demandeAdmission = this.demandeAdmissionId
        }

        if (this.contactId) {
          this.getAutresAutorisationsDePratique.pp = this.contactId
        }

        if (!this.getAutresAutorisationsDePratique.id || this.getAutresAutorisationsDePratique.id == null) {
          this.createAutresAutorisationsDePratique(this.getAutresAutorisationsDePratique)
              .finally(() => {
                this.saveAttachments(
                    "demandeAdmission",
                    this.demandeAdmissionId,
                    () => {
                      this.overlay = false
                      this.redirect()
                    })
              })
        } else {
          this.updateAutresAutorisationsDePratique(this.getAutresAutorisationsDePratique)
              .finally(() => {
                this.saveAttachments(
                    "demandeAdmission",
                    this.demandeAdmissionId,
                    () => {
                      this.overlay = false
                      this.redirect()
                    })
              })
        }
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateForm(resetValidation = false) {
      this.valid = (this.$refs.form?.validate() || false) && this.getAutresAutorisationsDePratique

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
  },
}
</script>

<style>
</style>